var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"resourcePage"},[_c('div',{staticClass:"leftPage"},[_c('v-left',{ref:"left"})],1),_c('div',{staticClass:"middlePage"},[_c('v-middle',{ref:"middle"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }